<template>
  <div class="d-flex justify-content-between" style="width: 100%">
    <div style="width: 30%">
      <div class="d-flex flex-column">
        <select
          @change="
            computeBirAge(form.birthday[0], form.birthday[1], form.birthday[2])
          "
          v-validate="{
            required: validateOpen ? form.birthday[0] == '' : false,
          }"
          :class="{
            'is-invalid': errors.has('year')||isBirdayError,
            'form-control': true,
            'font-size-control': true,
          }"
          data-bropup-up="false"
          :data-vv-name="'year'"
          data-vv-as="年"
          v-model="form.birthday[0]"
        >
          <option value="">年份</option>
          <option
            v-for="(opt, y_opt_i) in birthYearOpt"
            :key="`birth-year-${y_opt_i}`"
            :value="opt"
          >
            {{ opt - 1911 }}年
          </option>
        </select>
        <span v-if="errors.has('year') && showErrText" class="waring-text">
          {{ errors.first("year") }}
        </span>
      </div>
    </div>
    <div class="flex-grow-1">
      <div
        class="d-flex justify-content-center"
        style="font-size: 16px; margin-top: 8px"
      >
        /
      </div>
    </div>
    <div style="width: 30%">
      <div class="d-flex flex-column">
        <select
          @change="
            computeBirAge(form.birthday[0], form.birthday[1], form.birthday[2])
          "
          v-validate="{
            required: validateOpen ? form.birthday[1] == '' : false,
          }"
          :class="{
            'is-invalid': errors.has('month')||isBirdayError,
            'form-control': true,
            'font-size-control': true,
          }"
          :data-vv-name="'month'"
          data-vv-as="月"
          v-model="form.birthday[1]"
        >
          <option value="">月份</option>
          <option
            v-for="(opt, m_opt_i) in birthMonthOpt"
            :key="`birth-month-${m_opt_i}`"
            :value="opt"
          >
            {{ opt }}月
          </option>
        </select>

        <span v-if="errors.has('month') && showErrText" class="waring-text">
          {{ errors.first("month") }}
        </span>
      </div>
    </div>
    <div class="flex-grow-1">
      <span
        class="d-flex justify-content-center"
        style="font-size: 16px; margin-top: 8px"
        >/</span
      >
    </div>
    <div style="width: 30%">
      <div class="d-flex flex-column">
        <select
          @change="
            computeBirAge(form.birthday[0], form.birthday[1], form.birthday[2])
          "
          v-validate="{
            required: validateOpen ? form.birthday[2] == '' : false,
          }"
          :class="{
            'is-invalid': errors.has('day')||isBirdayError,
            'form-control': true,
            'font-size-control': true,
          }"
          :data-vv-name="'day'"
          data-vv-as="日"
          v-model="form.birthday[2]"
        >
          <option value="">日期</option>
          <option
            v-for="(opt, d_opt_i) in birthDateOpt"
            :key="`birth-date-${d_opt_i}`"
            :value="opt"
          >
            {{ opt }}日
          </option>
        </select>
        <span v-if="errors.has('day') && showErrText" class="waring-text">
          {{ errors.first("day") }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { computeAge } from "@/service";
export default {
  props: {
    validateOpen: {
      type: Boolean,
      default: true,
    },
    showErrText: {
      type: Boolean,
      default: true,
    },
    isBirdayError: {
      type: Boolean,
      default: false,
    },
    itemData: {},
  },
  data() {
    return {
      today: window.moment(),
      form: {
        birthday: ["", "", ""],
        age: "",
        date: "",
      },
      birthYearOpt: [],
      birthMonthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      birthDateOpt: [],
    };
  },
  mounted() {
    let start = this.today.year();
    this.birthYearOpt = Array.apply(null, { length: 101 }).map(function (
      value,
      index
    ) {
      return start - index;
    });
    if (this.itemData) this.getData();
  },
  methods: {
    computeBirAge(year, month, day) {
      // 計算保險年齡
      this.updateDate();
      if (year !== "" && month !== "" && day !== "") {
        this.form.age = "";
        this.form.date = new Date(year, month - 1, day);
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        computeAge(
          this.$store.state.userInfo.id,
          `${year}-${month}-${day}`
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            this.form.age = result.body.age;
          } else {
            this.form.age = "計算錯誤";
          }
          this.$emit("getTime", this.form);
        });
        this.form.age = "計算中...";
      } else {
        this.form.date = "";
        this.form.age = "";
        this.$emit("getTime", this.form);
      }
    },
    updateDate() {
      let year = this.form.birthday[0];
      let month = this.form.birthday[1];
      if (!year || !month) return;
      let dt = new Date(year, month, 0).getDate();
      this.birthDateOpt = [];
      for (var i = 0; i < dt; i++) {
        this.birthDateOpt.push(i + 1);
      }
    },
    validateAll() {
      return this.$validator.validateAll();
    },
    reset() {
      this.form = {
        birthday: ["", "", ""],
        age: "",
        date: "",
      };
      this.errors.clear();
    },
    getData() {
      console.log(this.itemData)
      this.form.birthday[0] =
        typeof this.itemData.getFullYear === "function"
          ? this.itemData.getFullYear()
          : "";
      this.form.birthday[1] =
        typeof this.itemData.getMonth === "function"
          ? this.itemData.getMonth() + 1
          : "";
      this.form.birthday[2] =
        typeof this.itemData.getDate === "function"
          ? this.itemData.getDate()
          : "";
       this.updateDate();
    },
  },
};
</script>
<style lang="scss" scoped>
.waring-text {
  margin-top: 5px;
  margin-left: 5px;
  font-size: 13px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #de4054;
}

@media screen and (max-width: 992px) {
  .font-size-control {
    font-size: 12px !important;
  }
}
</style>
